import React, { createContext, useEffect, useCallback, FC } from 'react';

const EVENTS_MANAGER_ID = 'ptfl6';
const APP_DOWNLOAD_BUTTON_CLICKED_EVENT_ID = 'tw-ptfl6-r63jw';

type Props = {
  children: React.ReactNode
}

interface PixelTracking {
  trackAppDownload: () => void;
}

export const TrackContext = createContext<PixelTracking | undefined>(undefined);

const TrackProvider: FC<Props> = ({ children }) => {
  useEffect(() => {
    const win = window as any;
    const doc = document;

    if (!win.twq) {
      const twitterPixelLoader = (e: any, t: Document, n: string) => {
        let s: any, u: any, a: any;
        if (e.twq) return;
        s = e.twq = function() {
          s.exe ? s.exe.apply(s, arguments) : s.queue.push(arguments);
        };
        s.version = '1.1';
        s.queue = [];

        u = t.createElement(n);
        u.async = true;
        u.src = 'https://static.ads-twitter.com/uwt.js';

        a = t.getElementsByTagName(n)[0];
        if (a && a.parentNode) {
          a.parentNode.insertBefore(u, a);
        }
      };

      twitterPixelLoader(win, doc, 'script');
    }

    win.twq('config', EVENTS_MANAGER_ID);
  }, []);

  const trackAppDownload = useCallback(() => {
    if ((window as any).twq) {
      (window as any).twq('event', APP_DOWNLOAD_BUTTON_CLICKED_EVENT_ID, {});
    }
  }, []);

  return (
    <TrackContext.Provider value={{ trackAppDownload }}>{children}</TrackContext.Provider>
  );
};

export default TrackProvider;